import { forwardRef } from "react";
import { mergeProps } from "../../shared";
import { Text } from "../../typography";
import { useFieldLabelProps } from "./FieldContext";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "label";

function RequiredIndicator() {
  return /*#__PURE__*/_jsx("span", {
    "aria-hidden": "true",
    className: "o-ui-field-label-required",
    children: "*"
  });
}

export function InnerLabel(props) {
  const [fieldProps] = useFieldLabelProps(props);
  const {
    as = DefaultElement,
    children,
    forwardedRef,
    required,
    ...rest
  } = mergeProps(props, fieldProps);
  return /*#__PURE__*/_jsxs(Text, { ...mergeProps(rest, {
      as,
      className: "o-ui-field-label",
      ref: forwardedRef,
      size: "md"
    }),
    children: [children, required && /*#__PURE__*/_jsx(RequiredIndicator, {})]
  });
}
InnerLabel.defaultElement = DefaultElement;
export const Label = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerLabel, { ...props,
  forwardedRef: ref
}));